import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { APISource } from '../../../../../../../typings/Source.interface';
import { ClickableArea, ClickableAreaProps } from '../../../common/base/Button';
import { StyledCard } from '../../../common/base/Card';
import Icon, { IconName } from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import Tooltip from '../../../common/base/Tooltip';
import { Div } from '../../../common/helpers/StyledUtils';
import { Truncatable } from '../../../common/Truncatable';
import { DashboardContext } from '../DashboardContext';
import { capitalizeFirstLetter } from '../../../../utils';
interface Props extends Pick<ClickableAreaProps, 'to' | 'onClick'> {
  source: APISource;
  action_button?: JSX.Element;
}
const SourceCard: React.FC<Props> = t0 => {
  const $ = _c(29);
  const {
    source,
    onClick,
    to
  } = t0;
  const {
    source_types
  } = useContext(DashboardContext);
  const source_type = source_types?.[source.type];
  let t1;
  if ($[0] !== source.config || $[1] !== source.type || $[2] !== source_types) {
    t1 = source_types?.[(source.config.auth_type || source.type).toUpperCase()]?.label;
    $[0] = source.config;
    $[1] = source.type;
    $[2] = source_types;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const auth_label = t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      x: 2,
      y: 1.5
    };
    t3 = {
      justify: "space-between",
      align: "center"
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "center",
      justify: "space-between"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      align: "center"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = (source_type?.icon || "webhook") as IconName;
  let t7;
  if ($[8] !== t6) {
    t7 = <Icon icon={t6} muted={true} left={true} pointer={true} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = !!source.disabled_at;
  let t9;
  if ($[10] !== source.name) {
    t9 = <Truncatable text={source.name} />;
    $[10] = source.name;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <Text w={100} ellipsis={true} mono={true} muted={t8}>{t9}</Text>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <Div flex={t5} w={100}>{t7}{t10}</Div>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== auth_label || $[19] !== source.authenticated || $[20] !== source.disabled_at) {
    t12 = source.authenticated && !source.disabled_at && <Tooltip side="bottom" tooltip={capitalizeFirstLetter(`${auth_label || ""} authentication enabled`.trim())}><Icon muted={true} icon="verification" right={true} pointer={true} /></Tooltip>;
    $[18] = auth_label;
    $[19] = source.authenticated;
    $[20] = source.disabled_at;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <Div flex={t4} w={100}>{t11}{t12}</Div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== onClick || $[26] !== t13 || $[27] !== to) {
    t14 = <StyledCard overflow_hidden={true}><ClickableArea p={t2} flex={t3} onClick={onClick} to={to}>{t13}</ClickableArea></StyledCard>;
    $[25] = onClick;
    $[26] = t13;
    $[27] = to;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};
export default SourceCard;